'use es6';

import PropTypes from 'prop-types';
import { List } from 'immutable';
import ChatHeadingConfigPropType from 'conversations-prop-types/prop-types/ChatHeadingConfigPropType';
import { RIGHT_ALIGNED, WidgetLocationProp } from '../constants/WidgetLocations';
import WidgetHeader from './WidgetHeader';
import VisitorWidgetStyleWrapper from '../../presentation-components/VisitorWidgetStyleWrapper';
import { HEADER_HEIGHT } from '../../widget-dimensions/constants/dimensions';
import styled, { css } from 'styled-components';
import WidgetViews from '../proptypes/WidgetViews';
import { THREAD_VIEW } from '../constants/views';
import { getBrandStyle } from '../util/color';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WidgetBodyDiv = styled.div.withConfig({
  displayName: "VisitorWidget__WidgetBodyDiv",
  componentId: "d1p7dt-0"
})(["display:flex;flex-direction:column;height:100%;background-color:#fff;overflow:hidden;", ";"], ({
  theme
}) => {
  var _theme$config;
  return ((_theme$config = theme.config) === null || _theme$config === void 0 ? void 0 : _theme$config.isUngatedForUpdatedUI) && css(["border-start-end-radius:10px;"]);
});
export const WidgetBodyDivWrapper = styled.div.withConfig({
  displayName: "VisitorWidget__WidgetBodyDivWrapper",
  componentId: "d1p7dt-1"
})(["height:calc(100% - ", "px);", ";"], HEADER_HEIGHT, ({
  $background
}) => getBrandStyle($background));
const VisitorWidget = props => {
  const {
    backButtonDisabled,
    browserWindowHeight,
    browserWindowWidth,
    chatHeadingConfig,
    chatHeadingResponders,
    children,
    closeWidget,
    coloring,
    createNewThread,
    customHeaderText,
    inline,
    isPreview,
    isThreadAssigned,
    kbArticleDeepLink,
    restorePreviousViewFromKBArticle,
    mobile,
    navigateToKnowledgeBaseArticle,
    navigateToThreadList,
    officeHoursMessage,
    setWidgetSize,
    showAvailabilityMessage,
    showBackButton,
    size,
    style,
    toggleWidgetSizeForKBArticle,
    typicalResponseTimeMessage,
    unseenThreadsCountExcludingCurrentThread,
    view,
    viewKBArticleExpanded,
    widgetLocation,
    widgetSize
  } = props;
  return /*#__PURE__*/_jsxs(VisitorWidgetStyleWrapper, {
    browserWindowHeight: browserWindowHeight,
    browserWindowWidth: browserWindowWidth,
    inline: inline,
    size: size,
    style: style,
    mobile: mobile,
    widgetLocation: widgetLocation,
    widgetSize: widgetSize,
    children: [/*#__PURE__*/_jsx(WidgetHeader, {
      backButtonDisabled: backButtonDisabled,
      browserWindowHeight: browserWindowHeight,
      chatHeadingConfig: chatHeadingConfig,
      coloring: coloring,
      chatHeadingResponders: chatHeadingResponders,
      createNewThread: createNewThread,
      customHeaderText: customHeaderText,
      inline: inline,
      isThreadAssigned: isThreadAssigned,
      kbArticleDeepLink: kbArticleDeepLink,
      restorePreviousViewFromKBArticle: restorePreviousViewFromKBArticle,
      mobile: mobile,
      navigateToKnowledgeBaseArticle: navigateToKnowledgeBaseArticle,
      navigateToThreadList: navigateToThreadList,
      officeHoursMessage: officeHoursMessage,
      onClose: closeWidget,
      preview: isPreview,
      toggleWidgetSizeForKBArticle: toggleWidgetSizeForKBArticle,
      setWidgetSize: setWidgetSize,
      showAvailabilityMessage: showAvailabilityMessage,
      showBackButton: showBackButton,
      typicalResponseTimeMessage: typicalResponseTimeMessage,
      unseenThreadsCountExcludingCurrentThread: unseenThreadsCountExcludingCurrentThread,
      view: view,
      viewKBArticleExpanded: viewKBArticleExpanded
    }), /*#__PURE__*/_jsx(WidgetBodyDivWrapper, {
      $background: coloring.accentColor,
      children: /*#__PURE__*/_jsx(WidgetBodyDiv, {
        children: children
      })
    })]
  });
};
VisitorWidget.propTypes = {
  backButtonDisabled: PropTypes.bool,
  browserWindowHeight: PropTypes.number.isRequired,
  browserWindowWidth: PropTypes.number.isRequired,
  chatHeadingConfig: ChatHeadingConfigPropType.isRequired,
  chatHeadingResponders: PropTypes.instanceOf(List),
  children: PropTypes.node.isRequired,
  closeWidget: PropTypes.func.isRequired,
  coloring: PropTypes.object.isRequired,
  createNewThread: PropTypes.func,
  customHeaderText: PropTypes.string,
  inline: PropTypes.bool.isRequired,
  isPreview: PropTypes.bool.isRequired,
  isThreadAssigned: PropTypes.bool.isRequired,
  kbArticleDeepLink: PropTypes.string,
  mobile: PropTypes.bool.isRequired,
  navigateToKnowledgeBaseArticle: PropTypes.func,
  navigateToThreadList: PropTypes.func,
  officeHoursMessage: PropTypes.string,
  restorePreviousViewFromKBArticle: PropTypes.func,
  setWidgetSize: PropTypes.func,
  showAvailabilityMessage: PropTypes.bool,
  showBackButton: PropTypes.bool.isRequired,
  size: PropTypes.string,
  style: PropTypes.object,
  toggleWidgetSizeForKBArticle: PropTypes.func,
  typicalResponseTimeMessage: PropTypes.string,
  unseenThreadsCountExcludingCurrentThread: PropTypes.number,
  view: WidgetViews,
  viewKBArticleExpanded: PropTypes.bool,
  widgetLocation: WidgetLocationProp,
  widgetSize: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }).isRequired
};
VisitorWidget.defaultProps = {
  customHeaderText: null,
  inline: false,
  isPreview: false,
  isThreadAssigned: false,
  mobile: false,
  onUpdateOpened: () => {},
  widgetLocation: RIGHT_ALIGNED,
  view: THREAD_VIEW
};
VisitorWidget.displayName = 'VisitorWidget';
export default VisitorWidget;